import { z } from "zod";

// Validation schemas -- updated iteration 039: Firebase Authentication
// Login/register/refresh handled client-side by Firebase SDK

export const syncSchema = z.object({
  first_name: z.string().min(1).optional(),
  last_name: z.string().min(1).optional(),
});

export type SyncInput = z.infer<typeof syncSchema>;
